import { render, staticRenderFns } from "./NuovaAnagraficaPotenziale.vue?vue&type=template&id=56c9da23&"
import script from "./NuovaAnagraficaPotenziale.vue?vue&type=script&lang=js&"
export * from "./NuovaAnagraficaPotenziale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports